<template>
  <section>
  	  <el-row class="statusRow">
      <el-col>
        <el-row :gutter="10">
          <el-select class="xs24" v-model="pdata.creative_bale_id" filterable  clearable placeholder="请选择创意组合名称">
	        	<el-option v-for="(item,i) in creativeGroupList" :key="item.creativebale_id" :label="item.name" :value="item.creativebale_id"></el-option>
		      </el-select>
        </el-row>
      </el-col>
    </el-row>

    <el-row class="statusRow">
      <el-button size="medium" type="primary" @click="addProduct">新增</el-button>
      <el-button size="medium" type="success" @click="changeStatus(false,1)">启用</el-button>
      <el-button size="medium" type="danger" @click="changeStatus(false,0)">禁用</el-button>
<!--      <el-button size="medium" type="info" @click="changeStatus(false,-1)">删除</el-button>-->
			 <el-input
		        @clear="getList"
		        @keyup.enter.native="search"
		        ref="input"
		        class="search  xs24"
		        v-model="pdata.kw"
		        clearable
		        placeholder="请输入产品名称/创意名称"
		        :suffix-icon="pdata.kw.length>0?'':'el-icon-search'"
		      >
		    </el-input>
			<el-select v-model="pdata.status" filterable placeholder="请选择产品状态">
							<el-option key="" label="选择产品状态" value="" ></el-option>
					    <el-option key="0" label="禁用" value="0" ></el-option>
					    <el-option key="1" label="启用" value="1" ></el-option>
			</el-select>
		  
		  
    </el-row>
    



    <!--列表-->
    <el-table
      :data="plist"
      style="width: 100%;min-width:1200px"
      @selection-change="select"
      stripe
      row-key="id"
    >
      <el-table-column type="selection"></el-table-column>
      <el-table-column prop="id" label="ID" width="50px" align="center"></el-table-column>
      <el-table-column prop="name" label="广告主游戏" align="left" >
        <template slot-scope="scope">
          <el-button
            type="text"
            @click="editProduct(scope.row)"
          >{{scope.row.name}}</el-button>
        </template>
      </el-table-column>
       <el-table-column prop="icon" label="产品来源" align="center">
        <template slot-scope="scope">
          <span v-if="scope.row.source==1">互导</span>
          <span v-if="scope.row.source==2">卖量</span>
          <span v-if="scope.row.source==3">测量</span>
        </template>
      </el-table-column>
      
      <el-table-column prop="box_name" label="中转盒子" align="center">
        
      </el-table-column>
      
       <el-table-column prop="icon" label="创意个数"  align="center">
        <template slot-scope="scope">
          <span>{{scope.row.creative_num.ok}}/{{scope.row.creative_num.count}}</span>
        </template>
      </el-table-column>
      
      <el-table-column prop="path" label="产品路径" width="250px" align="center"></el-table-column>
      <el-table-column prop="update_time" label="更新时间" width="220px" align="center"></el-table-column>
      
      <el-table-column prop="status" label="​产品状态"  align="center">
      	<template slot-scope="scope">
          <span>{{scope.row.status==1?'启用':'禁用'}}</span>
        </template>
      </el-table-column>
      
      <el-table-column prop="status" label="操作" width="250px" align="center">
      	<template slot-scope="scope">
		      	<el-button
		            size="mini"
		            :type="scope.row.status=='1'?'success':'danger'"
		            @click="editStatus(scope.row)"
		          >{{scope.row.status=='1'?'正常':'禁用'}}</el-button>
		       <el-button type="text"  @click="$router.push({name:'创意投放日志',params:{index_id:scope.row.id},query:{type:'creative'}})">更新日志</el-button>   
        </template>
      	
      </el-table-column>
    </el-table>
 
	 	 <div class="pageRow">
	      <el-pagination
	        class="pagination"
	        @size-change="SizeChange"
	        @current-change="CurrentChange"
	        :current-page.sync="pdata.page"
	        :page-sizes="[20, 40, 60, 80]"
	        :page-size="pdata.perpage"
	        background
	        layout="sizes, prev, pager, next, jumper"
	        :total="pdata.perpage*maxPage"
	      ></el-pagination>
	    </div>
 
 
    <el-dialog
      :title="isAdd?'新增创意':'编辑创意'"
      :visible.sync="editDialog"
      width="950px"
      :close-on-click-modal="false"
    >
      <el-form :model="chooseProduct" :rules="rules" ref="ruleForm" :label-width="formLabelWidth">
      	<el-form-item label="请选择中转盒子" prop="jump_type">
          <el-select v-model="chooseProduct.issued_app_id" filterable placeholder="请从产品管理里选择产品" :disabled="isAdd?false:true">
					    <el-option
					      v-for="item in baleBoxList"
					      :key="item.issued_app_id"
					      :label="item.name"
					      :value="item.issued_app_id"
					      default-first-option
					    ></el-option>
					  </el-select>
        </el-form-item>
        
        <el-form-item label="产品选择" prop="product_base_id">
            <el-select v-model="chooseProduct.product_base_id" filterable placeholder="请从产品管理里选择产品" :disabled="isAdd?false:true">
					    <el-option
					      v-for="item,index in productList"
					      :key="index"
					      :label="item.name"
					      :value="item.product_base_id"
					      default-first-option
					    ></el-option>
					  </el-select>
        </el-form-item>
        <el-form-item label="" prop="data"  class="myItems" style="margin-bottom: 0;"> 
         	<el-row  :gutter="5" style="margin:0;">
         			<el-col :span="3"  style="margin:0  0 10px 0;">序号</el-col>
         			<el-col :span="5"  style="margin:0  0 10px 0;">创意名称</el-col>
         			<el-col :span="4"  style="margin:0  0 10px 0;">创意权重</el-col>
         			<el-col :span="3"  style="margin:0  0 10px 0;">创意帧数</el-col>
         			<el-col :span="4"  style="margin:0  0 10px 0;">角标</el-col>
         			<el-col :span="5"  style="margin:0  0 10px 0;">操作</el-col>
         		</el-row>
        </el-form-item>
         <el-form-item label="" prop="data"  class="myItems">
         		<div style="width: 120px; display: inline-block;">
         			<el-button
			            size="mini"
			            type="primary"
			            @click="addCreative(true)"
			          >新增</el-button>	
         		</div>
         		
        		<!--编辑-->
        		<div v-for="(item,index) in chooseProduct.data" :class="item.isAdd?'add':'edit'" >
	        	  <div class="" v-if="!item.isAdd" >
		     			 		 <img :src="item.icon_url"/>
		     			 		 <p class="txt">{{item.rename}}</p>
				          <el-button
				            size="mini"
				            type="primary"
				            @click="editCreative(index)"
				          >编辑</el-button>
	        	  </div> 
	        	  <!--新增-->
	        	  <div v-else>
	        	  	<el-row  :gutter="5" style="margin:0;">
	         			
		     			 	<el-col :span="3"  style="margin:0  0 10px 0;">
		     			
		     			 		{{index+1}}:
		     			 	</el-col>
		     			 	<el-col :span="5"  style="margin:0  0 10px 0;">
		     			 		
		     			 		 <el-input   v-model="item.rename" placeholder="请输入创意名称" class="input" clearable style="width:100%;"></el-input>
		     			 		
		     			 	</el-col>
		     			 	<el-col :span="4"  style="margin:0  0 10px 0;">
		     			 	
		     			 		<el-input  v-model="item.weight" placeholder="请输入创意权重" class="input" clearable style="width:100%;"></el-input>
		     			 	</el-col>
		     			 	<el-col :span="3"  style="margin:0  0 10px 0;">
		     			 
		     			 		<el-input   v-model="item.frame" placeholder="请输入创意帧数" class="input" clearable style="width:100%;"></el-input>
		     			 	</el-col>
		     			 	<el-col :span="4"  style="margin:0  0 10px 0;">
		     			 		 
		     			 		 <el-select v-model="item.heat" filterable placeholder="请选择角标" >
		     			 		 	<el-option key="0" label="无" value="0"></el-option>
		     			 		 	<el-option key="1" label="红点" value="1"></el-option>
		     			 		 	<el-option key="2" label="热门" value="2"></el-option>
		     			 		 	<el-option key="3" label="New" value="3"></el-option>
		     			 		 	<el-option key="4" label="感叹号" value="4"></el-option>
								  </el-select>
		     			 	</el-col> 
		     			 	<el-col :span="5"  style="margin:0  0 10px 0;">
		     			 		<el-button
				            size="mini"
				            :type="item.status=='1'?'success':'danger'"
				            @click="changeCreative(index)" 
				          >{{item.status=='1'?'正常':'禁用'}}</el-button>
				          <!--<el-button
				            size="mini"
				            type="primary"
				            @click="editCreative(index)"
				          >编辑</el-button>-->
				          
		     			 	</el-col> 
	
	         		</el-row>
	         		<el-row  :gutter="5" style="margin:0;" >
	         			<el-col :span="3"  style="margin:0  0 10px 0;">&nbsp;</el-col> 	
	         			<el-col :span="4"  style="margin:0  0 10px 0;">
	         			 
					          <UploadImg :image="item.icon_url" v-on:update:image="imageUploadSuccess($event,index)" :url="url+'creative/icon'"></UploadImg>
					          <el-input :disabled="!item.isAdd" v-model="item.icon_name" placeholder="请输入图片名称" class="input" clearable style="width:100%;"></el-input>
					       
					       </el-col> 	
					      <el-col :span="17"  style="margin:0  0 10px 0;">
					       		<ul class="iconImgList" v-if="creativeIconList.length>0">
					       			<li v-for="(it,idx) in creativeIconList" @click="copyIconImage(it,index)">
					       				<img :src="it.url"/>
					       			</li>
					       			<li>推荐Icon</li>
					       		</ul>
	         			</el-col> 	
	         		</el-row>
	        	  </div>
        	  </div>
         		
        </el-form-item>
      
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="editDialog = false">取 消</el-button>
        <el-button type="primary" @click="submit">确 定</el-button>
      </div>
    </el-dialog>
    
    <el-dialog title="更新日志" :visible.sync="logDialog">
      <el-table :data="plog">
        <el-table-column prop="username" label="操作人员" width="150"></el-table-column>
        <el-table-column prop="create_time" label="更新时间" width="200"></el-table-column>
        <el-table-column prop="content" label="备忘"></el-table-column>
      </el-table>
    </el-dialog>
  </section>
</template>

<script>
import { getCreativeBaleList, sgpstatus, saddgp, seditgp, geditgp,sclog ,newsplist,selectCreative,getCreativeGroup,getCreativeBaleBox,baseUrl,getCreativeIcon} from "../../api/api";
import UploadImg from "./../uploadImg.vue";
import Test from "../../components/searchApp.vue";

export default {
  components: {
    UploadImg,
    Test
  },
  data() {
    return {
      rules: {
        icon: [
          { required: true, message: "请上传创意图片", trigger: "change" }
        ],
        frame: [{ required: true, message: "请输入图片帧数", trigger: "blur" }],
        type: [
          { required: true, message: "请选择创意类型", trigger: "change" }
        ],
        device: [
          { required: true, message: "请选择支持设备", trigger: "change" }
        ],
        heat: [
          { required: true, message: "请选择广告创意展示", trigger: "change" }
        ],
        product_id: [{ required: true, message: "请选择产品", trigger: "blur" }]
      },
      pdata: {
        creative_bale_id:"",
        status: "",
        kw: "",
        page:1,
        perpage:10,
      },
      issued_app_id:"",
      plist: [],
      maxPage: 1,
      config: [],
      jumpBox: false,
      cproduct: "",

      tags: [],
      chooseProduct: {},
      editDialog: false,
      formLabelWidth: "120px",
      log: "", //日志


      isAdd: false,
      cP: {
        index_id: "",
        status: "1",
        log: ""
      },
      selectProduct: [],
      logDialog:false,
      plog:[],
      productList:[],
      creativeGroupList:[],
      baleBoxList:[],
      url:baseUrl,
      creativeIconList:[],
    };
  },
  watch: {
   
    'pdata.source': {
      handler(n, o) {
       
        this.getList();
        
      },
      deep: true
    },
    'pdata.status':{
    	handler(n, o) {
       
        this.getList();
        
      },
      deep: true
    },
    'pdata.kw': {
      handler(n, o) {
       
        this.getList();
        
      },
      deep: true
    },
    'pdata.creative_bale_id':{
    	handler(n, o) {
    		this.$router.push({name:'创意组合详情',params:{index_id:this.pdata.creative_bale_id}});
        
        this.getList();
      },
      deep: true
    },
    'chooseProduct.issued_app_id':{
    	handler(n, o) {
        this.getNewAppList();
      },
      deep: true
    },
    'chooseProduct.product_base_id':{
    	handler(n, o) {
				this.productList.forEach((v,i)=>{
        		if(v.product_base_id==this.chooseProduct.product_base_id){
        			this.productName=v.name;
        			if(this.chooseProduct.data[0].isAdd==true){
        				this.chooseProduct.data[0].rename=v.name;
        			}
        		}
        	})
        this.getCreativeIconList();
      },
      deep: true
    	
    }
  },
  created() {
    let that = this;
    document.onkeypress = function(e) {
      var keycode = document.all ? event.keyCode : e.which;
      if (keycode == 13 && that.editDialog) {
        that.submit();
        return false;
      }
    };
  },
  methods: {
  	 copyIconImage(e,index){
  	
  	 			this.chooseProduct.data[index].icon_url=e.url;
		  	 	this.chooseProduct.data[index].icon_name=e.name;
		  	 	this.chooseProduct.data[index].icon_id=e.id;
		  	 	this.$forceUpdate();
  	 },
  	 imageUploadSuccess(e,index){
  
  	 	if(typeof(e)=='object'){
  	 			this.chooseProduct.data[index].icon_url=e.icon_url;
		  	 	this.chooseProduct.data[index].icon_name=e.icon_name;
		  	 	this.chooseProduct.data[index].icon_id=e.icon_id;
		  	 	this.$forceUpdate();
  	 	}
  	 	else if(e==''){
  	 		  this.chooseProduct.data[index].icon_url='';
		  	 	this.chooseProduct.data[index].icon_name='';
		  	 	this.chooseProduct.data[index].icon_id='';
		  	 	this.$forceUpdate();
  	 	}
  	 
  	 	
  	 	
  	 },
  	 getNewAppList(){
  	 	  var p = "";
	      selectCreative("issued_app_id="+this.chooseProduct.issued_app_id, this.$cookie.getCookie("login")).then(res => {
	        if (res.code == 200) {
	          this.productList = res.data;
	        }
	      });
  	 },
    SizeChange(v) {
      this.pdata.perpage = v;
      this.getList();
    },
    CurrentChange(v) {
      this.pdata.page = v;
      this.getList();
    },
    getList() {
      var p = "";
      for (var k in this.pdata) {
        if (this.pdata[k]) p += k + "=" + this.pdata[k] + "&";
      }
      getCreativeBaleList(p, this.$cookie.getCookie("login")).then(res => {
        if (res.code == 200) {
        	if(res.data.list&&res.data.list.length>0){
          this.plist = res.data.list;
          this.maxPage = res.data.max_page;
        	}
        	else{
        		this.plist =[];
         		this.maxPage =1;
        	}
        }
      });
    },
    getConfig() {
      if (this.$store.config) {
        this.config = this.$store.config.ad_creative_type;
        this.tags = this.$store.config.product_tag;
      } else {
        setTimeout(() => {
          this.getConfig();
        }, 50);
      }
    },


    search() {
      // this.$refs.input.blur();
      this.getList();
    },
    addCreative(){
    	this.chooseProduct.data.push({
    			"issued_app_id":"",
    		  "creative_type":"2",
					"rename":"",
					"weight":"5",
					"frame":"",
					"heat":"",
					"icon":"",
					"icon_name":"",
					"status":1,
					"isAdd":true,
				})
    },
    editCreative(index){
    	this.chooseProduct.data[index].isAdd=true;
    	this.chooseProduct.data.push(this.chooseProduct.data[index]);
    	this.chooseProduct.data.splice(index,1);
    	
    	this.$forceUpdate();
    },
    editProduct(d) {
    	geditgp('index_id='+d.id, this.$cookie.getCookie("login")).then(res => {
	        if (res.code == 200) {
	          this.chooseProduct = res.data;
	          this.chooseProduct.index_id = this.chooseProduct.id;
	          delete this.chooseProduct.id;
	        }
	      });
      this.editDialog = true;
      this.isAdd = false;
    },
    changeCreative(index){

			this.chooseProduct.data[index].status = this.chooseProduct.data[index].status == 1 ? "0" : "1";

    },
    editStatus(s) {
      var p = {
        index_id: s.id,
        status: s.status == "1" ? "0" : "1",
        log: ""
      };
     this.$confirm(p.status==1?'启用需二次确认, 是否继续?':'禁用需二次确认, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
       }).then(() => {
        sgpstatus(p, this.$cookie.getCookie("login")).then(res => {
          if (res.code == 200) {
            this.getList();
          }
        });
      });
    },
     changeStatus(isSingle, s) {
      if (!isSingle && this.selectProduct.length == 0) {
        this.$message.error("请先选择需要批量操作的数据");
        return;
      }
      if (isSingle) {
        this.cP.index_id = s.id;
        this.cP.status = s.status == 1 ? "0" : "1";
      } else {
        this.cP.status = s;
      }

      if (this.cP.status == 0) {
        this.cP.log = "禁用产品";
      } else if (this.cP.status == 1) {
        this.cP.log = "启用产品";
      } else if (this.cP.status == -1) {
        this.cP.log = "删除产品";
      }
      this.$confirm(this.cP.status==1?'启用需二次确认, 是否继续?':'禁用需二次确认, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
	      sgpstatus(this.cP, this.$cookie.getCookie("login")).then(res => {
	        if (res.code == 200) {
	          this.getList();
	          this.$message({ message: this.cP.log + "成功", type: "success" });
	        }
	      });
      })
    },
  
    
    addProduct() {
      this.chooseProduct = {
      	"issued_app_id":this.issued_app_id,
				"jump_type":"1",
				"product_base_id":"",
				"creative_bale_id":this.pdata.creative_bale_id,
				data:[{
					"creative_type":"2",
					"rename":"",
					"weight":"5",
					"frame":"",
					"heat":"",
					"icon":"",
					"icon_name":"",
					"status":1,
					"isAdd":true,
				}]
        
      };
      this.editDialog = true;
      this.isAdd = true;
    },
    select(s) {
      this.selectProduct = s;
      var p = "测";
      s.forEach((v, i) => {
        p += "," + v.id;
      });
      this.cP.index_id = p.slice(2);
    },
    submit() {
    	for(var i=0;i<this.chooseProduct.data.length;i++){
    		if(this.chooseProduct.data[i].rename==''||this.chooseProduct.data[i].weight==''||this.chooseProduct.data[i].icon_url==''){
    			this.$message.error('添加创意不能有留空');
    			return false;
    			
    		}
    	}
      this.$refs.ruleForm.validate(valid => {
        if (valid) {
          if (this.isAdd) {
            saddgp(this.chooseProduct, this.$cookie.getCookie("login")).then(
              res => {
                if (res.code == 200) {
                  this.$message({ message: "新增创意成功", type: "success" });
                  this.getList();
                  this.editDialog = false;
                } else {
                  this.$message.error(res.msg);
                }
              }
            );
          } else {
            // this.$prompt("请输入编辑原因", "提示", {
            //   confirmButtonText: "确定",
            //   cancelButtonText: "取消",
            //   inputPattern: /^[\s\S]*.*[^\s][\s\S]*$/,
            //   inputErrorMessage: "内容不能为空"
            // }).then(({ value }) => {
            this.chooseProduct.log = "编辑内容";
            seditgp(this.chooseProduct, this.$cookie.getCookie("login")).then(
              res => {
                if (res.code == 200) {
                  this.$message({ message: "编辑创意成功", type: "success" });
                  this.getList();
                  this.editDialog = false;
                } else {
                  this.$message.error(res.msg);
                }
              }
            );
            // });
          }
        } else {
          return false;
        }
      });
    },
    getBaleBox(){
    	getCreativeGroup('', this.$cookie.getCookie("login")).then(res => {
        if (res.code == 200) {
        	if(res.data&&res.data.length>0){
        		this.creativeGroupList = res.data;
        	}
        }
      });
      getCreativeBaleBox('', this.$cookie.getCookie("login")).then(res => {
        if (res.code == 200) {
        	if(res.data&&res.data.length>0){
        		this.baleBoxList = res.data;
        	}
        }
      });
    },
    getCreativeIconList(){
    	if(this.chooseProduct.issued_app_id==''||this.chooseProduct.product_base_id==''){
    		return false;
    	}
    	var p ='issued_app_id='+this.chooseProduct.issued_app_id+'&product_base_id='+this.chooseProduct.product_base_id;
    	getCreativeIcon(p, this.$cookie.getCookie("login")).then(res => {
        if (res.code == 200) {
        	if(res.data&&res.data.length>0){
        		this.creativeIconList = res.data;
        	}
         
          
        }
      });
    }
  },
  mounted() {
  	this.pdata.creative_bale_id = this.$route.params.index_id;
  	
    this.getList();
    this.getConfig();
    //this.getNewAppList();
    this.getBaleBox();
  }
};
</script>

<style scoped="scoped">
	ul.iconImgList { width: 100%; }
	ul.iconImgList li{
		list-style: none;
		float: left;
		width: 60px;
		height: 60px;
		margin:  5px;
		cursor: copy;
		line-height: 60px;
		text-align: center;
	}
		ul.iconImgList li img{
			width: 100%;
			height: 100%;
		}
		.edit{
			width: 120px;
			min-height: 120px;
			vertical-align: middle;
			display: inline-block;
			text-align: center;
			margin: 10px;
			position: relative;
		}
		.edit img{
			width: 120px;
			height: 120px;
			display: block;
		}
		.edit button{
			display: none;
			position: absolute;
			left: 0;
			right: 0;
			margin: 0 auto;
			transform: translateY(-50%);
			top: 50%;
			
		}
		.edit:hover button{
			display: block;
		}
		.edit .txt{
			margin: 0;
			padding: 0;
			height: 25px;
			line-height: 25px;
		}
</style>
<style>
.w260 {
  width: 260px;
}
.myItems .el-form-item__content{
	margin-left: 0 !important;
}
</style>



// WEBPACK FOOTER //
// CreativeGroup.vue?7a1a1cd3